import React from 'react';
import { formatCurrency } from '@sailpoint/bva-core'

// results: { fiveYearTotalSavings, currencySymbol }
export default function ResultsSummary({ results }) {
    if (!results) return null;
    return (
        <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white p-6 rounded-lg shadow-lg mb-8 text-center">
            <h2 className="text-2xl md:text-3xl">Estimated 5 Year Benefit</h2>
            <p className="text-4xl md:text-5xl mt-2">
                {formatCurrency(results.fiveYearTotalSavings, results.currencySymbol)}
            </p>
        </div>
    );
}
